/* product-sticky-cart.js
   Sticky add-to-cart bar — IntersectionObserver on the ATC button.
   Loaded deferred from sections/main-product.liquid.
*/
(function () {
  function initStickyCart() {
    var observerTarget = document.querySelector('.product-form__buttons');
    var stickyCart = document.querySelector('.product__sticky-cart');
    if (!observerTarget || !stickyCart) return;

    var lastScrollY = window.scrollY;
    var isScrollingDown = true;

    var callback = function (entries) {
      entries.forEach(function (entry) {
        var currentScrollY = window.scrollY;
        isScrollingDown = currentScrollY > lastScrollY;
        lastScrollY = currentScrollY;

        /* Shopify design mode causes the sticky cart to show when it shouldn't */
        if (isScrollingDown) {
          if (!entry.isIntersecting && !DeviceDetector.isMobile() && !Shopify.designMode) {
            stickyCart.classList.remove('is-hidden');
          } else if (!entry.isIntersecting && DeviceDetector.isMobile() && window.scrollY > window.innerHeight && !Shopify.designMode) {
            stickyCart.classList.remove('is-hidden');
          } else {
            stickyCart.classList.add('is-hidden');
          }
        } else {
          if (entry.isIntersecting) {
            stickyCart.classList.add('is-hidden');
          }
        }
      });
    };

    var observer = new IntersectionObserver(callback, { threshold: 0.8 });
    observer.observe(observerTarget);

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', function () {
        observer.unobserve(observerTarget);
        initStickyCart();
      });
      document.addEventListener('shopify:section:unload', function () {
        observer.unobserve(observerTarget);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyCart);
  } else {
    initStickyCart();
  }
})();
